"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertAggregation = exports.convertMeasure = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2021 GoodData Corporation
var sdk_model_1 = require("@gooddata/sdk-model");
var FilterConverter_1 = require("./FilterConverter");
var ObjRefConverter_1 = require("../ObjRefConverter");
var compact_1 = tslib_1.__importDefault(require("lodash/compact"));
var constants_1 = require("./constants");
function convertMeasure(measure) {
    var definition = measure.measure.definition;
    var convertedDefinition = convertMeasureDefinition(definition);
    var format = getFormat(measure);
    var formatProp = format ? { format: format } : {};
    var alias = measure.measure.alias ? measure.measure.alias : measure.measure.title;
    var aliasProp = alias ? { alias: alias } : {};
    return tslib_1.__assign(tslib_1.__assign({ localIdentifier: measure.measure.localIdentifier, definition: convertedDefinition }, aliasProp), formatProp);
}
exports.convertMeasure = convertMeasure;
function convertAggregation(aggregation) {
    if (aggregation === "approximate_count") {
        // Bear doesn't support approximate_count so transparently fallback to exact count.
        return "count";
    }
    return aggregation;
}
exports.convertAggregation = convertAggregation;
function convertMeasureDefinition(definition) {
    if (sdk_model_1.isMeasureDefinition(definition)) {
        return convertSimpleMeasureDefinition(definition);
    }
    else if (sdk_model_1.isPoPMeasureDefinition(definition)) {
        return convertPopMeasureDefinition(definition);
    }
    else if (sdk_model_1.isPreviousPeriodMeasureDefinition(definition)) {
        return convertPreviousPeriodMeasureDefinition(definition);
    }
    else if (sdk_model_1.isArithmeticMeasureDefinition(definition)) {
        return convertArithmeticMeasureDefinition(definition);
    }
    else {
        throw Error("The measure definition is not supported: " + JSON.stringify(definition));
    }
}
function convertSimpleMeasureDefinition(definition) {
    var measureDefinition = definition.measureDefinition;
    var filters = measureDefinition.filters
        ? compact_1.default(measureDefinition.filters.map(FilterConverter_1.convertMeasureFilter))
        : [];
    var filtersProp = filters.length ? { filters: filters } : {};
    var aggregation = convertAggregation(measureDefinition.aggregation);
    var aggregationProp = aggregation ? { aggregation: aggregation } : {};
    var computeRatio = measureDefinition.computeRatio;
    var computeRatioProp = computeRatio ? { computeRatio: computeRatio } : {};
    return {
        measure: tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({ item: ObjRefConverter_1.toBearRef(measureDefinition.item) }, filtersProp), aggregationProp), computeRatioProp),
    };
}
function convertPopMeasureDefinition(definition) {
    var popMeasureDefinition = definition.popMeasureDefinition;
    return {
        popMeasure: {
            measureIdentifier: popMeasureDefinition.measureIdentifier,
            popAttribute: ObjRefConverter_1.toBearRef(popMeasureDefinition.popAttribute),
        },
    };
}
function convertPreviousPeriodMeasureDefinition(definition) {
    var previousPeriodMeasure = definition.previousPeriodMeasure;
    return {
        previousPeriodMeasure: {
            measureIdentifier: previousPeriodMeasure.measureIdentifier,
            dateDataSets: previousPeriodMeasure.dateDataSets.map(function (dateDataSet) { return ({
                dataSet: ObjRefConverter_1.toBearRef(dateDataSet.dataSet),
                periodsAgo: dateDataSet.periodsAgo,
            }); }),
        },
    };
}
function convertArithmeticMeasureDefinition(definition) {
    var arithmeticMeasure = definition.arithmeticMeasure;
    return {
        arithmeticMeasure: {
            measureIdentifiers: arithmeticMeasure.measureIdentifiers.slice(),
            operator: arithmeticMeasure.operator,
        },
    };
}
function getFormat(measure) {
    var _a = measure.measure, definition = _a.definition, format = _a.format;
    if (format) {
        return format;
    }
    var isArithmeticMeasureChange = sdk_model_1.isArithmeticMeasureDefinition(definition) && definition.arithmeticMeasure.operator === "change";
    if (isArithmeticMeasureChange) {
        return constants_1.DEFAULT_PERCENTAGE_FORMAT;
    }
    if (sdk_model_1.isMeasureDefinition(definition)) {
        var measureDefinition = definition.measureDefinition;
        if (measureDefinition.computeRatio) {
            return constants_1.DEFAULT_PERCENTAGE_FORMAT;
        }
        if (measureDefinition.aggregation === "count") {
            return constants_1.DEFAULT_INTEGER_FORMAT;
        }
    }
    return undefined;
}
//# sourceMappingURL=MeasureConverter.js.map